module.exports = __webpack_public_path__ + "static/media/caricon.4777d1d6.svg";